module.exports = __webpack_public_path__ + "static/img/exImg.fa314e76.png";